const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
  window.location.hostname === '[::1]' ||
  // 127.0.0.0/8 IPv4 localhost range
  window.location.hostname.match(
    /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
  )
);

export function register(config) {
  if (process.env.NODE_ENV === "production" && 'serviceWorker' in navigator) {
    const publicUrl = new URL(process.env.PUBLIC_URL, window.location.href);

    if (publicUrl.origin !== window.location.origin) {
      // Different origin → don’t register
      return;
    }

    const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;
    const doRegister = () => {
      if (isLocalhost) {
        // Localhost: validate SW
        checkValidServiceWorker(swUrl, config);
        navigator.serviceWorker.ready.then(() => {
          console.log('Service Worker ready (localhost). Cache-first.');
          setInterval(() => {
            navigator.serviceWorker.getRegistrations().then(registrations => {
              registrations.forEach(r => r.update());
            });
          }, 2 * 60 * 1000);
        });
      } else {
        // Production: register directly
        registerValidSW(swUrl, config);
        navigator.serviceWorker.ready.then(() => {
          console.log('Service Worker ready (production).');
          setInterval(() => {
            navigator.serviceWorker.getRegistrations().then(registrations => {
              registrations.forEach(r => r.update());
            });
          }, 1 * 60 * 1000);
        });
      }
    };

    // ✅ Fix: ensure registration runs even if page already loaded
    if (document.readyState === "complete") {
      doRegister();
      
    } else {
      window.addEventListener("load", doRegister);
    }
  }
}

function registerValidSW(swUrl, config) {
  navigator.serviceWorker
    .register(swUrl)
    .then(registration => {
      registration.onupdatefound = () => {
        const installingWorker = registration.installing;
        if (!installingWorker) return;
        installingWorker.onstatechange = () => {
          if (installingWorker.state === "installed") {
            if (navigator.serviceWorker.controller) {
              console.log("New content available, will be used after tab refresh.");
              if (config && config.onUpdate) {
                config.onUpdate(registration);
              }
            } else {
              console.log("Content cached for offline use.");
              if (config && config.onSuccess) {
                config.onSuccess(registration);
              }
            }
          }
        };
      };
    })
    .catch(error => {
      console.error("Error during service worker registration:", error);
    });
}

function checkValidServiceWorker(swUrl, config) {
  fetch(swUrl, { headers: { "Service-Worker": "script" } })
    .then(response => {
      const contentType = response.headers.get("content-type");
      if (
        response.status === 404 ||
        (contentType != null && contentType.indexOf("javascript") === -1)
      ) {
        navigator.serviceWorker.ready.then(registration => {
          registration.unregister().then(() => {
            window.location.reload();
          });
        });
      } else {
        registerValidSW(swUrl, config);
      }
    })
    .catch(() => {
      console.log("No internet connection. App running offline.");
    });
}

export function unregister() {
  if ("serviceWorker" in navigator) {
    navigator.serviceWorker.ready
      .then(registration => {
        registration.unregister();
      })
      .catch(error => {
        console.error(error.message);
      });
  }
}
